if (!customElements.get('activity-scroller')) {
  class ActivityScroller extends HTMLElement {
    connectedCallback() {
      this._list = this.querySelector('[data-activities-list]');
      this._prevBtn = this.querySelector('[data-activities-prev]');
      this._nextBtn = this.querySelector('[data-activities-next]');

      if (!this._list || !this._prevBtn || !this._nextBtn) return;

      this._isRtl = this.dataset.direction === 'rtl';

      this._onScroll = () => this._updateArrows();
      this._onResize = () => this._updateArrows();
      this._onPrev = (e) => this._scroll(e, -1);
      this._onNext = (e) => this._scroll(e, 1);

      this._list.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      this._prevBtn.addEventListener('click', this._onPrev);
      this._nextBtn.addEventListener('click', this._onNext);

      this._updateArrows();
    }

    disconnectedCallback() {
      if (this._list) this._list.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onResize);
      if (this._prevBtn) this._prevBtn.removeEventListener('click', this._onPrev);
      if (this._nextBtn) this._nextBtn.removeEventListener('click', this._onNext);
    }

    _scroll(event, direction) {
      event.preventDefault();
      const step = Math.max(this._list.clientWidth * 0.9, 200);
      const delta = (this._isRtl ? -direction : direction) * step;
      this._list.scrollBy({ left: delta, behavior: 'smooth' });
    }

    _updateArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this._list;
      const tolerance = 2;

      const maxScroll = scrollWidth - clientWidth;
      const atStart = this._isRtl
        ? Math.abs(scrollLeft) >= maxScroll - tolerance
        : scrollLeft <= tolerance;
      const atEnd = this._isRtl
        ? scrollLeft >= -tolerance
        : scrollLeft >= maxScroll - tolerance;

      const overflows = scrollWidth - clientWidth > tolerance;

      this._prevBtn.hidden = !overflows || atStart;
      this._nextBtn.hidden = !overflows || atEnd;
    }
  }

  customElements.define('activity-scroller', ActivityScroller);
}
